exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonbar{display:flex;justify-content:center;width:auto;flex-wrap:nowrap;gap:1px}.buttonbar .button{min-width:50px;margin:0;box-shadow:none}@media screen and (max-width: 800px){.buttonbar .button{padding:8px}}", ""]);

